// extracted by mini-css-extract-plugin
export default {"titre":"AmendementShow_titre__mdyYJ","mainButton":"AmendementShow_mainButton__iUnG7"};